"use client";

import React, { useEffect } from "react";
import Chatbot from "../components/Chatbot";
import Footer from '../components/common/Footer';

function Services() {
  useEffect(() => {
    // Mobile menu toggle
    const menuBtn = document.getElementById("menu-btn");
    const mobileMenu = document.getElementById("mobile-menu");

    const handleMenuToggle = () => {
      if (mobileMenu) {
        mobileMenu.classList.toggle("hidden");
      }
    };

    if (menuBtn) {
      menuBtn.addEventListener("click", handleMenuToggle);
    }

    const initSlider = () => {
      if (typeof window !== "undefined" && window.jQuery) {
        window.jQuery(".slider").slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          focusOnSelect: true,
          autoplay: true,
          autoplaySpeed: 3000,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                centerMode: false,
              },
            },
          ],
        });
      }
    };

    // Check if jQuery and slick are loaded
    const checkJQuery = () => {
      if (typeof window !== "undefined" && window.jQuery && window.jQuery.fn.slick) {
        initSlider();
      } else {
        // If not loaded yet, try again in 100ms
        setTimeout(checkJQuery, 100);
      }
    };

    checkJQuery();

    return () => {
      if (menuBtn) {
        menuBtn.removeEventListener("click", handleMenuToggle);
      }

      // Destroy slick sliders if they exist
      if (typeof window !== "undefined" && window.jQuery) {
        if (window.jQuery(".slider").slick) {
          window.jQuery(".slider").slick("unslick");
        }
      }
    };
  }, []);

  return (
    <div>
      <Chatbot />

      <main className="flex overflow-hidden flex-col pb-11 bg-white">
        {/* Hero Section */}
        <header className="flex relative flex-col items-center self-stretch px-20 pb-36 w-full text-white min-h-[457px] max-md:px-5 max-md:pb-24 max-md:max-w-full">
          <img
            src="assets/img/service-bg.png"
            alt="Hero Background"
            className="object-cover absolute inset-0 size-full"
          />

          <nav className="flex items-center justify-between w-full max-w-[1248px] px-5 py-3 relative mx-auto">
            {/* Logo */}
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/6f92263fde794fd91fb10442848bed84da061cb6?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
              alt="Company logo"
              className="w-[101px] object-contain"
            />

            {/* Mobile Menu Button */}
            <button id="menu-btn" className="block md:hidden text-white focus:outline-none">
              <svg
                className="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>

            {/* Navigation Wrapper */}
            <div id="menu" className="hidden md:flex relative items-center">
              {/* Background behind menu */}
              <div className="absolute inset-0 w-full h-full bg-white rounded-full"></div>

              {/* Menu Items */}
              <ul className="flex gap-10 px-8 py-3 text-indigo-950 text-base font-medium relative z-10">
                <li className="cursor-pointer">
                  <a href="/">Home</a>
                </li>
                <li className="font-bold cursor-pointer">
                  <a href="/services">Services</a>
                </li>
                <li className=" cursor-pointer">
                  <a href="/projects">Projects</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/about">About</a>
                </li>
              </ul>
            </div>

            {/* Contact Button */}
            <button className="px-5 py-2 bg-white text-indigo-950 font-bold rounded-full hidden md:block">
              <a href="/contact">Contact Us</a>
            </button>

            {/* Mobile Dropdown */}
            <div id="mobile-menu" className="absolute top-full left-0 w-full bg-white shadow-md hidden md:hidden">
              <ul className="flex flex-col items-center gap-4 py-4 text-indigo-950 font-medium">
                <li className="cursor-pointer">
                  <a href="/">Home</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/services">Services</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/projects">Projects</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/about">About</a>
                </li>
                <li>
                  <a href="/contact">
                    <button className="px-5 py-2 bg-white text-indigo-950 font-bold rounded-full">
                      Contact Us
                    </button>
                  </a>
                </li>
              </ul>
            </div>
          </nav>

          <p className="relative  mt-20 text-base text-center text-white w-[417px]">Our Services</p>
          <h1 className="relative  text-6xl font-semibold text-center text-white max-md:max-w-full max-md:text-4xl">
            Reliable Electrical & Solar <br />
            Solutions for Every Need
          </h1>
        </header>

        <div className="container">
          <h2 className="mt-24 text-4xl font-semibold text-center text-black mx-auto w-full max-w-[471px] max-md:mt-10">
            Tailored Electric Solutions for Homes & Industries!
          </h2>
          <p className="mt-8 text-base text-center text-black mx-auto w-full max-w-[468px]">
            At Al-Abbas Electric & Solar Power, we excel in solar and electric solutions with{" "}
            <span className="font-bold">8+ years</span> of expertise.
          </p>

          <div className="flex-container">
            {/* First Column */}
            <div className="column">
              {/* Blue Stats Card */}
              <div className="stats-card blue-card">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/8cfe5210e44a0c6ecba49cd25e274aa09278d663"
                  className="card-icon"
                  alt="Statistics icon"
                />
                <div>
                  <div className="stat-number">60+</div>
                  <div className="stat-label">Successful Projects</div>
                </div>
                <p className="card-text">At Al-Abbas Electric & Solar Power, we excel in solar.</p>
              </div>

              {/* Orange Stats Card */}
              <div className="stats-card orange-card">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/bce3d2e778e68fb7f70c4b5b1878ebc922fa502c"
                  className="card-icon"
                  alt="Staff icon"
                />
                <div>
                  <div className="stat-number">35</div>
                  <div className="stat-label">Certified Staff</div>
                </div>
                <p className="card-text">At Al-Abbas Electric & Solar Power, we excel in solar.</p>
              </div>
            </div>

            {/* Middle Column - Image */}
            <div className="column center-image-container">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/454023987e20ab522be152b16ecebd2dd0c9349d"
                className="center-image"
                alt="Electric services"
              />
            </div>

            {/* Third Column */}
            <div className="column">
              {/* Dark Blue Stats Card */}
              <div className="stats-card dark-blue-card">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/bc1f66da1c583672400fc7b97b5136f57256d035"
                  className="card-icon"
                  alt="Clients icon"
                />
                <div>
                  <div className="stat-number">50+</div>
                  <div className="stat-label">Satisfied Clients</div>
                </div>
                <p className="card-text text-white">At Al-Abbas Electric & Solar Power, we excel in solar.</p>
              </div>

              {/* Teal Stats Card */}
              <div className="stats-card teal-card">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/05abae47feba4d7d783d9f514f3302bd6365e258"
                  className="card-icon"
                  alt="Awards icon"
                />
                <div>
                  <div className="stat-number">10</div>
                  <div className="stat-label">Awards Wins</div>
                </div>
                <p className="card-text">At Al-Abbas Electric & Solar Power, we excel in solar.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Services Section Header */}

        <h2 className="mt-24 text-4xl font-semibold text-center text-black mx-auto w-full max-w-[471px] max-md:mt-10">
          Powering Your World with Expert Electrical Solutions
        </h2>
        <p className="mt-8 text-base text-center text-black mx-auto w-full max-w-[468px]">
          We are a comprehensive electrical solutions provider, delivering expert services for all your needs.
        </p>

        <section className="self-start mt-16 w-full max-w-[1234px] mx-auto max-md:mt-10 max-md:max-w-full">
          {/* First Row */}
          <div className="flex flex-wrap justify-center gap-5 max-md:flex-col">
            {/* Solar Panel Service */}
            <article className="w-full sm:w-[calc(33.333%-20px)] min-w-[300px] max-w-[400px]">
              <div className="relative h-[450px] rounded-3xl overflow-hidden group">
                <img
                  src="assets/img/service (3).png"
                  className="absolute inset-0 w-full h-full object-cover transition-transform group-hover:scale-105"
                  alt="Solar panel installation"
                />
                <div className="absolute inset-0 bg-black/50 flex flex-col justify-end p-6">
                  <h3 className="text-2xl font-semibold text-white">Solar Panel Fixing</h3>
                  <p className="mt-3 text-base text-white">
                    As solar power demand rises, we bring top-notch solar solutions to your doorstep. Just give us a
                    call!
                  </p>
                  <div className="flex gap-3 mt-4">
                    <button className="flex items-center gap-2 px-4 py-2 text-xs font-medium text-white border border-white rounded-full hover:bg-white hover:text-black transition-colors">
                      <span>Book Now</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path
                          d="M5 12h14M12 5l7 7-7 7"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    <button className="flex items-center gap-2 px-4 py-2 text-xs font-medium text-white border border-white rounded-full hover:bg-white hover:text-black transition-colors">
                      <span>(Watch Demo)</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M5 3l14 9-14 9V3z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </article>

            {/* House Wiring Service */}
            <article className="w-full sm:w-[calc(33.333%-20px)] min-w-[300px] max-w-[400px]">
              <div className="relative h-[450px] rounded-3xl overflow-hidden group">
                <img
                  src="assets/img/service (1).png"
                  className="absolute inset-0 w-full h-full object-cover transition-transform group-hover:scale-105"
                  alt="House wiring repair"
                />
                <div className="absolute inset-0 bg-black/50 flex flex-col justify-end p-6">
                  <h3 className="text-2xl font-semibold text-white">House Wiring Repair</h3>
                  <p className="mt-3 text-base text-white">
                    Expert House Wiring Repairs – Quality Service at Affordable Rates!
                  </p>
                  <div className="flex gap-3 mt-4">
                    <button className="flex items-center gap-2 px-4 py-2 text-xs font-medium text-white border border-white rounded-full hover:bg-white hover:text-black transition-colors">
                      <span>Book Now</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path
                          d="M5 12h14M12 5l7 7-7 7"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    <button className="flex items-center gap-2 px-4 py-2 text-xs font-medium text-white border border-white rounded-full hover:bg-white hover:text-black transition-colors">
                      <span>(Watch Demo)</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M5 3l14 9-14 9V3z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </article>

            {/* Electrical Welding Service */}
            <article className="w-full sm:w-[calc(33.333%-20px)] min-w-[300px] max-w-[400px]">
              <div className="relative h-[450px] rounded-3xl overflow-hidden group">
                <img
                  src="assets/img/service (4).png"
                  className="absolute inset-0 w-full h-full object-cover transition-transform group-hover:scale-105"
                  alt="Electrical welding"
                />
                <div className="absolute inset-0 bg-black/50 flex flex-col justify-end p-6">
                  <h3 className="text-2xl font-semibold text-white">Electrical Welding</h3>
                  <p className="mt-3 text-base text-white">
                    We provide top-quality electrical welding with reliability ensuring 24/7 protection around the
                    year.
                  </p>
                  <div className="flex gap-3 mt-4">
                    <button className="flex items-center gap-2 px-4 py-2 text-xs font-medium text-white border border-white rounded-full hover:bg-white hover:text-black transition-colors">
                      <span>Book Now</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path
                          d="M5 12h14M12 5l7 7-7 7"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    <button className="flex items-center gap-2 px-4 py-2 text-xs font-medium text-white border border-white rounded-full hover:bg-white hover:text-black transition-colors">
                      <span>(Watch Demo)</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M5 3l14 9-14 9V3z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </article>
          </div>

          {/* Second Row */}
          <div className="flex flex-wrap justify-center gap-5 mt-6 max-md:flex-col">
            {/* Industrial Wiring Service */}
            <article className="w-full sm:w-[calc(33.333%-20px)] min-w-[300px] max-w-[400px]">
              <div className="relative h-[450px] rounded-3xl overflow-hidden group">
                <img
                  src="assets/img/service (5).png"
                  className="absolute inset-0 w-full h-full object-cover transition-transform group-hover:scale-105"
                  alt="Industrial wiring"
                />
                <div className="absolute inset-0 bg-black/50 flex flex-col justify-end p-6">
                  <h3 className="text-2xl font-semibold text-white">Industrial Wiring</h3>
                  <p className="mt-3 text-base text-white">
                    AC power plugs and sockets link electrical devices to the mains power supply in buildings and other
                    locations.
                  </p>
                  <div className="flex gap-3 mt-4">
                    <button className="flex items-center gap-2 px-4 py-2 text-xs font-medium text-white border border-white rounded-full hover:bg-white hover:text-black transition-colors">
                      <span>Book Now</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path
                          d="M5 12h14M12 5l7 7-7 7"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    <button className="flex items-center gap-2 px-4 py-2 text-xs font-medium text-white border border-white rounded-full hover:bg-white hover:text-black transition-colors">
                      <span>(Watch Demo)</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M5 3l14 9-14 9V3z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </article>

            {/* Street Light Service */}
            <article className="w-full sm:w-[calc(33.333%-20px)] min-w-[300px] max-w-[400px]">
              <div className="relative h-[450px] rounded-3xl overflow-hidden group">
                <img
                  src="assets/img/service (6).png"
                  className="absolute inset-0 w-full h-full object-cover transition-transform group-hover:scale-105"
                  alt="Street light fixing"
                />
                <div className="absolute inset-0 bg-black/50 flex flex-col justify-end p-6">
                  <h3 className="text-2xl font-semibold text-white">Street Light Fixing</h3>
                  <p className="mt-3 text-base text-white">
                    Al-Abbas Electric & Solar ensures bright, safe streets with expert light installation and
                    maintenance.
                  </p>
                  <div className="flex gap-3 mt-4">
                    <button className="flex items-center gap-2 px-4 py-2 text-xs font-medium text-white border border-white rounded-full hover:bg-white hover:text-black transition-colors">
                      <span>Book Now</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path
                          d="M5 12h14M12 5l7 7-7 7"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    <button className="flex items-center gap-2 px-4 py-2 text-xs font-medium text-white border border-white rounded-full hover:bg-white hover:text-black transition-colors">
                      <span>(Watch Demo)</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M5 3l14 9-14 9V3z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </article>

            {/* Home Maintenance Service */}
            <article className="w-full sm:w-[calc(33.333%-20px)] min-w-[300px] max-w-[400px]">
              <div className="relative h-[450px] rounded-3xl overflow-hidden group">
                <img
                  src="assets/img/service (2).png"
                  className="absolute inset-0 w-full h-full object-cover transition-transform group-hover:scale-105"
                  alt="Home maintenance"
                />
                <div className="absolute inset-0 bg-black/50 flex flex-col justify-end p-6">
                  <h3 className="text-2xl font-semibold text-white">Home Maintenance</h3>
                  <p className="mt-3 text-base text-white">
                    Al-Abbas Electric & Solar offers expert home maintenance for a safe, comfortable living space.
                  </p>
                  <div className="flex gap-3 mt-4">
                    <button className="flex items-center gap-2 px-4 py-2 text-xs font-medium text-white border border-white rounded-full hover:bg-white hover:text-black transition-colors">
                      <span>Book Now</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path
                          d="M5 12h14M12 5l7 7-7 7"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    <button className="flex items-center gap-2 px-4 py-2 text-xs font-medium text-white border border-white rounded-full hover:bg-white hover:text-black transition-colors">
                      <span>(Watch Demo)</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M5 3l14 9-14 9V3z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </section>
      </main>

      {/* Slider Wrapper */}
      <div className="slider-container">
        <div className="slider">
          <div>
            <img src="assets/img/1.png" alt="Image 1" />
          </div>
          <div>
            <img src="assets/img/2.png" alt="Image 2" />
          </div>
          <div>
            <img src="assets/img/3.png" alt="Image 3" />
          </div>
          <div>
            <img src="assets/img/4.png" alt="Image 4" />
          </div>
          <div>
            <img src="assets/img/5.png" alt="Image 5" />
          </div>
          <div>
            <img src="assets/img/6.png" alt="Image 6" />
          </div>
          <div>
            <img src="assets/img/7.png" alt="Image 7" />
          </div>
        </div>
      </div>

      <div className="power-up-container">
        <div className="power-up-content">
          <h1 className="font-medium">Let's Power Up Together!</h1>
          <p className="text-[17px] my-5 text-gray-600">
            Have questions or need expert electrical and solar solutions?
            <br />
            Our team is ready to assist you. Get in touch today!
          </p>

          <div className="power-up-form">
            <input type="text" placeholder="Enter Your Name" />
            <input type="text" placeholder="Write Your Phone" />
            <select>
              <option value="">Select Service</option>
              <option>Solar Solutions</option>
              <option>Street Pole</option>
              <option>Electrical Services</option>
            </select>
            <button>Get Free Quotation</button>
          </div>
        </div>

        <div className="power-up-image">
          <img src="assets/img/man.png" alt="Man with headphones" />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Services;